var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComingSoonEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 181,
    viewBox: "0 0 180 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90.5,
    r: 90,
    fill: "#F8F8F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3277_11665)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M118.732 132.692C118.515 132.735 118.276 132.779 118.016 132.822V130.087C115.216 131.715 107.077 132.171 94.3154 129.111C91.9063 128.525 90.0832 126.376 90.1483 123.902C90.1483 123.859 90.1483 123.837 90.1483 123.837L91.0599 97.4019C91.1901 91.8024 97.0501 86.854 100.24 82.2312C105.449 74.5481 109.291 71.6833 114.76 59.8331C115.107 59.0518 115.433 58.2705 115.737 57.4891C90.0832 63.4142 66.0574 51.8896 60.2626 48.8945C61.4346 53.2569 66.2528 63.4793 68.2061 67.5813C72.9591 72.3995 75.1729 79.6918 83.5071 87.6353C85.9161 89.9142 87.3486 93.0395 87.4137 96.3602L88.2601 119.995C88.2601 120.972 88.0648 121.884 87.7392 122.665C86.8277 125.009 84.2233 126.181 81.7491 125.725C67.8154 122.99 61.3043 129.697 60.9137 130.087C58.8953 136.794 57.8535 143.826 57.8535 150.923H121.076V150.727C121.076 144.607 120.295 138.552 118.732 132.692Z",
    fill: "#B2B2B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.27 86.9834L72.3732 73.8311C62.9972 61.2648 57.9186 46.0289 57.8535 30.4024V30.207H121.076C121.076 45.8987 115.997 61.1996 106.556 73.766L96.6594 86.9834C95.0967 89.0669 95.0967 91.9969 96.6594 94.0805L106.491 107.233C115.932 119.799 121.011 135.035 121.076 150.727V150.922H57.8535C57.8535 135.165 62.9321 119.929 72.3732 107.298L82.27 94.0805C83.8326 91.9969 83.8326 89.0669 82.27 86.9834Z",
    stroke: "white",
    strokeWidth: 3.25553,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2478 34.2423H123.614C125.893 34.2423 127.716 32.4193 127.716 30.2055C127.716 27.9266 125.893 26.1035 123.614 26.1035H55.2478C53.034 26.1035 51.2109 27.9266 51.2109 30.2055C51.2109 32.4193 53.034 34.2423 55.2478 34.2423Z",
    fill: "#DBDBDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.614 146.82H55.2478C53.034 146.82 51.2109 148.643 51.2109 150.922C51.2109 153.136 53.034 154.959 55.2478 154.959H123.614C125.893 154.959 127.716 153.136 127.716 150.922C127.716 148.643 125.893 146.82 123.614 146.82Z",
    fill: "#DBDBDD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3277_11665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.8305,
    height: 128.919,
    fill: "white",
    transform: "translate(51.0811 26.041)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingSoonEmptyState);
export default __webpack_public_path__ + "static/media/ComingSoonEmptyState.d9621f3c6a94c7ff2acd013eed8f56a7.svg";
export { ForwardRef as ReactComponent };